// UI strings (Swedish). Mirror keys in content/en/ui.js later.
export const ui = {
  bookCta: "Boka tid",
  menu: "Meny",
  closeMenu: "Stäng meny",
  close: "Stäng",
  skipToContent: "Hoppa till innehållet",
  readMore: "Läs mer",
  selectedArea: "Valt område",
  areaConditions: "Besvär vi arbetar med här",
  areaTreatments: "Behandlingar som kan vara aktuella",
  areaDisclaimer: "Vilken behandling som passar avgörs alltid vid läkarbedömningen.",
  switchArea: "Byt område",
  readMoreArea: "Läs mer om besvär",
  showOnMap: "Visa på karta",
  bookIn: (city) => `Boka tid i ${city}`,
  opensBokadirekt: "öppnas hos BokaDirekt",
  ratingOf: (count) => `${count} betyg på BokaDirekt`,
  verified: (d) => `Kontrollerat ${d}`,
};
